module.exports = __webpack_public_path__ + "image/2.ae0f70a.png";